<template>
  <info-page
    title="Vamos te explicar o passo a passo!"
  >
    <template #image>
      <bg-illustration name="boy-talking" />
    </template>
    <template #content>
      <bg-text type="body-sm">
        Logo nosso time entrará em contato com você para conversarmos mais sobre
        essa funcionalidade. Iremos te apresentar o funcionamento, processo,
        custos etc, sendo do seu interesse, liberamos a funcionalidade para o
        seu uso.
      </bg-text>
      <bg-text type="body-sm">
        Se quiser agilizar o contato mande um "Oi" no chat que abriu no
        canto inferior direito da tela, que responderemos mais rapidamente.
      </bg-text>
      <tr-button
        variant="raised"
        color="primary"
        label="Ir para tela inicial"
        type="button"
        @click="goToHome"
      />
    </template>
  </info-page>
</template>

<script setup>
import InfoPage from '@/commons/components/presentational/InfoPage.vue';
import { BgIllustration, BgText } from '@transfeeradev/bridge';
import { useRouter } from 'vue-router';

const router = useRouter();
const emit = defineEmits(['loading']);

emit('loading', false);

const goToHome = () => {
  router.push('/');
};
</script>
